import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=19845f9e&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderList.vue?vue&type=style&index=1&id=19845f9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19845f9e",
  null
  
)

component.options.__file = "orderList.vue"
export default component.exports